export default __webpack_public_path__ + "static/media/quesBankIcon.f850291b.svg";